<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			return {
				ws: {}
			};
		},
		methods: {
			fetchConfig() {
				this.$api.frontWebConfig({}, res => {
					if (res.code == 200) {
						let obj = {
							imageUrl: res.data.comImg,
							richText: res.data.comIntroduce,
							qrcodeUrl: res.data.erCodeUrl,
							addressList: JSON.parse(res.data.addressTraffic),
							contact: JSON.parse(res.data.contact),
							company_name: res.data.comName,
							company_name_en: res.data.comNameEn,
							zzdxywjyxkz: res.data.comLicense,
							zzdxywjyxkz_kdq: res.data.comLicenseRegion,
							jww: res.data.comArticle,
							jwgaba: res.data.comRecordSecurity,
							j_icp: res.data.comIcp,
							copyright_time: res.data.copyrightAt,
							web_name: res.data.webName
						}
						this.$store.state.websiteConfig = obj
					}
				})
			},
			openSocket() {
				if (this.$store.state.hasLogin) {
					this.ws = new WebSocket(this.$pub.wsUrl + this.$store.state.userinfo.userId)
					this.ws.onopen = () => {
						console.log('ws已开启')
					}
					this.ws.onmessage = (res) => {
						let data = JSON.parse(res.data)
						console.log('消息已接收')
						if (data.type == 1) {
							this.$store.state.messageCommodity = {
								id: data.lotId,
								price: data.price
							}
						} else {
							let remindType = data.remindType
							let title = ''
							let notifyType = 'warning'
							switch (remindType) {
								case 1:
									title = '开拍提醒'
									break;
								case 2:
									title = '截拍提醒'
									break;
								case 3:
									title = '加价提醒'
									break;
								case 4:
									notifyType = 'success'
									title = '拍卖成交提醒'
									break;
								case 5:
									notifyType = 'error'
									title = '自动竞拍价格超限'
									break;
								case 6:
									notifyType = 'error'
									title = '预设截拍时间超限'
									break;
								default:
									notifyType = 'error'
									title = '自动竞拍最高出价不足'
							}
							this.$notify({
								title: title,
								message: data.message,
								type: notifyType,
								position: 'bottom-right'
							});
						}
					}
					this.ws.onclose = () => {
						console.log('链接已关闭')
					}
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.fetchConfig()
			this.openSocket()
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
			this.ws.close()
		}
	};
</script>

<style lang="less">
	@import url("./public/variable.less");

	* {
		margin: 0px;
		padding: 0px;
		font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", sans-serif;
	}

	ul,
	li {
		list-style: none;
	}

	a {
		text-decoration: none;
	}

	.fixation {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
	}

	.scope-normal {
		color: @vue-text-color;
	}

	.scope-blue {
		color: @vue-text-color-active;
		text-decoration: underline;
		cursor: pointer;
	}

	.scope-grey {
		color: @vue-text-color-grey;
	}

	.scope-green {
		color: #53c41a;
	}

	.scope-red {
		color: #bd0101;
	}

	.scope-step {
		height: 100%;
		display: flex;
		align-items: center;

		img {
			width: 14px;
			height: 14px;
			margin-right: @vue-spacing-row-sm;
		}

		.scope-point {
			width: 14px;
			height: 14px;
			border-radius: @vue-border-radius-circle;
			margin-right: @vue-spacing-row-sm;
		}

		.scope-point-blue {
			background: @vue-bg-color-active;
		}

		.scope-point-green {
			background: @vue-bg-color-green;
		}

		.scope-point-red {
			background: @vue-bg-color-red;
		}

	}

	.scope-button {
		display: flex;

		.scope-button-item {
			cursor: pointer;
			margin-right: @vue-spacing-row-base;
		}

		.scope-button-grey {
			color: @vue-text-color-grey;
		}

		.scope-button-blue {
			color: @vue-text-color-active;
		}

		.scope-button-green {
			color: @vue-text-color-green;
		}

		.scope-button-red {
			color: @vue-text-color-red;
		}
	}

	.space-button {
		width: 100%;

		.space-button-item {
			width: 100%;
			height: 20px;
			display: flex;
			align-items: center;
			cursor: pointer;

			i {
				margin-right: @vue-spacing-row-sm / 2;
			}
		}

		.space-button-grey {
			color: @vue-text-color-grey;
		}

		.space-button-blue {
			color: @vue-text-color-active;
		}

		.space-button-green {
			color: @vue-text-color-green;
		}

		.space-button-red {
			color: @vue-text-color-red;
		}
	}

	.scope-image-breviary {
		width: 380px;
		display: block;

		img {
			height: 95px;
			max-width: 100%;
		}
	}

	.custom-scroll-bar::-webkit-scrollbar {
		width: 8px;
		height: 1px;
	}

	.custom-scroll-bar::-webkit-scrollbar-thumb {
		border-radius: 8px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #E3E3E3;
	}

	.custom-scroll-bar::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 8px;
		background: #F3F3F3;
	}

	.page-container {
		width: 100%;
		height: 100%;
		background: @vue-bg-color;
		border-radius: @vue-border-radius-lg;
		box-shadow: 0px 0px 10px @vue-border-color;
	}

	.generalDialog {
		.el-select {
			width: 100%;
		}
	}

	.commodity-block {
		width: 100%;
		display: flex;
		flex-wrap: wrap;

		.block-item:nth-child(4n) {
			margin-right: 0px;
		}

		.foot-item:nth-child(3n) {
			margin-right: 0px;
		}
	}

	.register-form {
		width: 800px;
		border: 2px solid @vue-border-color-red;
		border-radius: @vue-border-radius-lg * 2;
		padding: @vue-spacing-col-lg*2 @vue-spacing-row-lg*2;
		box-sizing: border-box;

		.welcome {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-base;
			color: @vue-text-color-red;
			margin-bottom: @vue-spacing-col-lg;
		}

		.dialog-button {
			align-items: center;
			height: 70px;
		}

		.dialog-button,
		.dialog-agreement {
			width: 100%;
			display: flex;
			padding-right: 120px;
			justify-content: center;
			box-sizing: border-box;

			.el-button {
				width: 120px;
			}

			a {
				color: @vue-text-color-active;
				margin: 0px @vue-spacing-row-sm / 2;
			}

			a:hover {
				color: @vue-text-color-red;
			}

			.el-checkbox {
				margin-right: @vue-spacing-row-sm;
			}
		}
	}

	.space-commodity {
		display: flex;
		justify-content: space-between;
		height: 90px;

		.space-commodity-image {
			width: 90px;
			height: 100%;
			display: flex;
			align-items: center;

			img {
				width: 100%;
				display: block;
			}
		}

		.space-commodity-info {
			width: calc(100% - 100px);
			height: 100%;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			align-content: center;

			.space-commodity-name,
			.space-commodity-author {
				width: 100%;
				font-size: @vue-font-size-min;
			}
		}
	}
</style>
